
























































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { randomId } from "@/utils";
import { MessageType } from "@/store/modules/enums";
import { NotifBatch, NotifGap, NotifProvider } from "@/store/modules/types";
import { BProgress, BProgressBar } from "bootstrap-vue";
import ModalHeader from "@/components/ModalHeader.vue";

@Component({
  components: {
    ModalHeader,
    BProgress,
    BProgressBar,
  },
  filters: {
    phone: function (phone: string) {
      if (!phone) return null;
      const parsed = parsePhoneNumberFromString(phone, "US");
      if (parsed) return parsed.formatNational();
      return phone;
    },
  },
  computed: mapState("patients", ["phoneStatus"]),
})
export default class GapNotifier extends Vue {
  @Prop(String) messageType!: MessageType;
  @Prop(String) readonly campaignId!: string;
  @Prop(String) readonly measureTypeId!: string;
  @Prop(Array) readonly gapList!: Array<any>;
  phoneStatus!: Array<any>;
  description = "";
  batchId: number | null = null;
  gaps = {
    notify: false,
    templates: Array<any>(),
    templateId: "",
    voice: {
      invalidStatus: ["NP", "WN", "UN", "IN", "ER"],
      preview: {
        gapId: null,
        phone: null,
        text: null,
      },
    },
    sms: {
      invalidStatus: ["NP", "NM", "WN", "IN", "ST", "ER"],
      preview: null,
    },
  };
  providers = {
    notify: false,
    enrolled: true,
    list: Array<any>(),
    templates: Array<any>(),
    templateId: "",
    voice: {
      preview: {
        provider: null,
        phone: null,
        text: null,
      },
    },
    sms: {
      preview: null,
    },
  };
  loading = false;

  setMessageType(type) {
    switch (type) {
      case MessageType.SMS:
        if (this.messageType === MessageType.EMAIL) {
          this.messageType = MessageType.SMS_EMAIL;
        } else if (
          this.messageType === MessageType.SMS_EMAIL ||
          this.messageType === MessageType.SMS
        ) {
          this.messageType = MessageType.EMAIL;
        }
        break;
      case MessageType.EMAIL:
        if (this.messageType === MessageType.SMS) {
          this.messageType = MessageType.SMS_EMAIL;
        } else if (
          this.messageType === MessageType.SMS_EMAIL ||
          this.messageType === MessageType.EMAIL
        ) {
          this.messageType = MessageType.SMS;
        }
        break;
      default:
        break;
    }
  }
  gapTemplateSelected(): boolean {
    if (this.gaps.templateId === "") {
      this.$modal.show("dialog", {
        title: "PatientCare",
        text: "Please select a <span class='wm-fw-500'>gap template</span>.",
      });
      return false;
    }
    return true;
  }
  providerTemplateSelected(): boolean {
    if (this.providers.templateId === "") {
      this.$modal.show("dialog", {
        title: "PatientCare",
        text: "Please select a <span class='wm-fw-500'>provider template</span>.",
      });
      return false;
    }
    return true;
  }
  get selectedGapTemplate(): any {
    if (this.gaps.templateId !== "") {
      const template = this.gaps.templates.find(
        (t) => t.id === this.gaps.templateId
      );
      return template;
    }
    return null;
  }
  get selectedProviderTemplate(): any {
    if (this.providers.templateId !== "") {
      const template = this.providers.templates.find(
        (t) => t.id === this.providers.templateId
      );
      return template;
    }
    return null;
  }
  get pendingGaps(): Array<any> {
    return this.gapList.filter((gap) => {
      return !gap.notifSent && !gap.notifError;
    });
  }
  get filteredProviders() {
    return this.providers.list.filter((provider) => {
      return provider.enrolled === this.providers.enrolled;
    });
  }
  get pendingProviders() {
    return this.providers.list.filter((provider) => {
      return provider.checked && !provider.notifSent && !provider.notifError;
    });
  }
  get patientCount() {
    const patients = [...new Set(this.gapList.map((gap) => gap.patientId))];
    return patients.length;
  }
  get gapsSent() {
    return this.gapList.filter((gap) => {
      return gap.notifSent && !gap.notifError;
    }).length;
  }
  get gapsWithErrors() {
    return this.gapList.filter((gap) => {
      return gap.notifError;
    }).length;
  }
  async showGapVoicePreview(gap) {
    if (!this.gapTemplateSelected()) return;
    this.gaps.voice.preview.gapId = gap.id;
    await this.getGapVoicePreviewText();
    this.$modal.show("gap-voice-preview");
  }
  async getGapTemplates() {
    try {
      const data: Array<any> = await this.$store.dispatch(
        "gaps/getMeasureTypeTemplates",
        this.measureTypeId
      );
      if (this.messageType === MessageType.VOICE) {
        this.gaps.templates = data.filter((t) => t.hasVoiceConfig);
      } else {
        this.gaps.templates = data.filter((t) => t.hasSMSConfig);
      }
      if (this.gaps.templates.length === 1) {
        this.gaps.templateId = this.gaps.templates[0].id;
      }
    } catch (error) {
      console.log(error);
    }
  }
  async getGapVoicePreviewText() {
    try {
      const { gapId } = this.gaps.voice.preview;
      const { templateId } = this.gaps;
      const data = await this.$store.dispatch("notifs/getGapVoicePreviewText", {
        gapId,
        templateId,
      });
      this.gaps.voice.preview.text = data;
    } catch (err) {
      console.log(err);
    }
  }
  async getGapVoicePreviewStream() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { gapId } = this.gaps.voice.preview;
      const { templateId } = this.gaps;
      const data = await this.$store.dispatch(
        "notifs/getGapVoicePreviewStream",
        {
          gapId,
          templateId,
        }
      );
      const blob = new Blob([data], { type: "audio/mp3" });
      const url = window.URL.createObjectURL(blob);
      const audio: HTMLAudioElement = new Audio(url);
      audio.play();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getGapVoicePreviewCall() {
    if (!this.gaps.voice.preview.phone) {
      this.$modal.show("dialog", {
        title: "PatientCare",
        text: "Please enter a <span class='wm-fw-500'>phone number</span>.",
      });
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { gapId, phone } = this.gaps.voice.preview;
      const { templateId } = this.gaps;
      const data = await this.$store.dispatch("notifs/getGapVoicePreviewCall", {
        gapId,
        templateId,
        phone,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getGapSMSPreview(gap) {
    if (!this.gapTemplateSelected()) return;
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { templateId } = this.gaps;
      const data = await this.$store.dispatch("notifs/getGapSMSPreview", {
        gapId: gap.id,
        templateId,
      });
      this.gaps.sms.preview = data;
      this.$modal.show("gap-sms-preview");
    } catch (err) {
      console.log(err);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getProviders() {
    if (this.providers.list.length) return;
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { campaignId, measureTypeId } = this;
      const gapList = this.gapList.map((item) => item.id).join();
      const data = await this.$store.dispatch("gaps/getGapProviders", {
        campaignId,
        measureTypeId,
        gapList,
      });
      this.providers.list = data.map((p) => {
        p.checked = false;
        p.notifSent = false;
        p.notifError = null;
        p.phones = [];
        if (String(p.phone).includes(",")) {
          let phones = String(p.phone).split(",");
          let all = "";
          phones.forEach((phone) => {
            phone = this.$options.filters!.phone(phone);
            all += all ? ", " + phone : phone;
            p.phones.push(phone);
          });
          p.phones.push(all);
          p.phone = all;
        } else {
          const phone = this.$options.filters!.phone(p.phone);
          p.phone = phone;
          p.phones.push(phone);
        }
        return p;
      });
    } catch (err) {
      console.log(err);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getProviderTemplates() {
    if (this.providers.templates.length) return;
    try {
      const data = await this.$store.dispatch(
        "gaps/getProviderTemplates",
        this.measureTypeId
      );
      if (this.messageType === MessageType.VOICE) {
        this.providers.templates = data.filter((t) => t.hasVoiceConfig);
      } else {
        this.providers.templates = data.filter((t) => t.hasSMSConfig);
      }
      if (this.providers.templates.length === 1) {
        const { id } = this.providers.templates[0];
        this.providers.templateId = id;
      }
    } catch (error) {
      console.log(error);
    }
  }
  async showProviderVoicePreview(provider) {
    if (!this.providerTemplateSelected()) return;
    this.providers.voice.preview.provider = provider;
    await this.getProviderVoicePreviewText();
    this.$modal.show("provider-voice-preview");
  }
  async getProviderVoicePreviewText() {
    try {
      const { provider } = this.providers.voice.preview;
      const { templateId } = this.providers;
      this.providers.voice.preview.text = await this.$store.dispatch(
        "notifs/getProviderVoicePreviewText",
        {
          provider,
          templateId,
        }
      );
    } catch (err) {
      console.log(err);
    }
  }
  async getProviderVoicePreviewStream() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { provider } = this.providers.voice.preview;
      const { templateId } = this.providers;
      const data = await this.$store.dispatch(
        "notifs/getProviderVoicePreviewStream",
        {
          provider,
          templateId,
        }
      );
      const blob = new Blob([data], { type: "audio/mp3" });
      const url = window.URL.createObjectURL(blob);
      const audio: HTMLAudioElement = new Audio(url);
      audio.play();
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getProviderVoicePreviewCall() {
    if (!this.providers.voice.preview.phone) {
      this.$modal.show("dialog", {
        title: "PatientCare",
        text: "Please enter a <span class='wm-fw-500'>phone number</span>.",
      });
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { provider, phone } = this.providers.voice.preview;
      const { templateId } = this.providers;
      const data = await this.$store.dispatch(
        "notifs/getProviderVoicePreviewCall",
        {
          provider,
          templateId,
          phone,
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getProviderSMSPreview(provider) {
    if (!this.providerTemplateSelected()) return;
    this.$store.commit("main/SET_LOADING", true);
    try {
      const { templateId } = this.providers;
      this.providers.sms.preview = await this.$store.dispatch(
        "notifs/getProviderSMSPreview",
        {
          provider,
          templateId,
        }
      );
      this.$modal.show("provider-sms-preview");
    } catch (err) {
      console.log(err);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async checkProviders() {
    this.providers.list.forEach((p) => {
      if (p.enrolled) {
        p.checked = true;
        p.notifSent = false;
        p.notifError = null;
      }
    });
  }
  async uncheckProviders() {
    this.providers.list.forEach((p) => {
      p.checked = false;
      p.notifSent = false;
      p.notifError = null;
    });
  }
  async setGapPhones() {
    this.$store.commit("main/SET_LOADING", true);
    // SET PHONE STATUS
    let invalidStatus: Array<any>;
    if (this.messageType === MessageType.VOICE) {
      invalidStatus = this.gaps.voice.invalidStatus;
    } else {
      invalidStatus = this.gaps.sms.invalidStatus;
    }
    // SET NOTIF GAP PHONES
    for (let i = 0; i < this.gapList.length; i++) {
      const gap = this.gapList[i];
      gap.notifPhones = [];
      // CHECK MOBILE PHONE
      if (gap.mobilePhone) {
        gap.notifPhones.push({
          key: randomId(6),
          type: "M ",
          number: gap.mobilePhone,
          status: this.phoneStatus.find((s) => s.id === gap.mobilePhoneStatusId)
            .name,
          valid: !invalidStatus.includes(gap.mobilePhoneStatusId),
        });
      }
      // CHECK HOME PHONE
      if (gap.homePhone) {
        gap.notifPhones.push({
          key: randomId(6),
          type: "H ",
          number: gap.homePhone,
          status: this.phoneStatus.find((s) => s.id === gap.homePhoneStatusId)
            .name,
          valid: !invalidStatus.includes(gap.homePhoneStatusId),
        });
      }
      // CHECK OTHER PHONE
      if (gap.otherPhone) {
        gap.notifPhones.push({
          key: randomId(6),
          type: "O",
          number: gap.otherPhone,
          status: this.phoneStatus.find((s) => s.id === gap.otherPhoneStatusId)
            .name,
          valid: !invalidStatus.includes(gap.otherPhoneStatusId),
        });
      }
      // CHECK OTHER PHONE 2
      if (gap.otherPhone2) {
        gap.notifPhones.push({
          key: randomId(6),
          type: "O",
          number: gap.otherPhone2,
          status: this.phoneStatus.find((s) => s.id === gap.otherPhone2StatusId)
            .name,
          valid: !invalidStatus.includes(gap.otherPhone2StatusId),
        });
      }
      // CHECK VALID PHONES
      const validPhones = gap.notifPhones.filter((p) => p.valid);
      //
      if (validPhones.length) {
        gap.notifPhone = validPhones[0];
      } else {
        gap.notifError = "NO VALID PHONES AVAILABLE";
        gap.notifPhone = gap.notifPhones[0];
      }
      //
    }
    //
    this.$store.commit("main/SET_LOADING", false);
  }
  async saveBatch() {
    if (this.providers.notify && !this.providerTemplateSelected()) return;
    if (this.gaps.notify && !this.gapTemplateSelected()) return;
    this.loading = true;
    try {
      const { campaignId, messageType, description } = this;
      const { templateId } = this.gaps;
      const providerTemplateId = this.providers.templateId;
      const batch: NotifBatch = {
        campaignId,
        templateId,
        providerTemplateId,
        messageType,
        description,
      };
      const data = await this.$store.dispatch("notifs/saveBatch", batch);
      this.batchId = data.batchId;
      this.saveGaps();
    } catch (error) {
      console.log(error);
    }
  }
  async saveGaps() {
    if (this.gaps.notify && this.pendingGaps.length) {
      const gap = this.pendingGaps[0];
      try {
        await this.$store.dispatch("notifs/saveGap", {
          batchId: this.batchId,
          gapId: gap.id,
          toPhone: gap.notifPhone.number,
        });
        if (this.messageType === MessageType.VOICE) {
          gap.voiceNotifCount++;
        } else {
          gap.smsNotifCount++;
        }
        gap.notifSent = true;
      } catch (error) {
        gap.notifError = error.response.data;
      } finally {
        this.saveGaps();
      }
    } else {
      this.saveProviders();
    }
  }
  async saveProviders() {
    if (this.providers.notify && this.pendingProviders.length) {
      const provider = this.pendingProviders[0];
      try {
        await this.$store.dispatch("notifs/saveProvider", {
          batchId: this.batchId,
          providerId: provider.id,
          minReferenceDate: provider.minReferenceDate,
          maxReferenceDate: provider.maxReferenceDate,
          gaps: provider.gaps,
          patients: provider.patients,
          toPhone: provider.phone,
        });
        provider.notifSent = true;
      } catch (error) {
        provider.notifError = error.response.data;
      } finally {
        this.saveProviders();
      }
    } else {
      this.loading = false;
    }
  }
  mounted() {
    // this.description = this.gapList[0].campaignName;
    this.description = "";
    this.getGapTemplates();
    this.setGapPhones();
  }
}
